<template>
  <div class="gov-detail-page">
    <div class="breadcrumb">
      <img :src="pointImg" alt="" class="breadcrumb-icon">
      <span>当前位置：
        <span class="breadcrumb-link" @click="$emit('go-home')">首页</span>
        <span> / </span>
        <span class="breadcrumb-link" @click="$emit('close')">政务资讯</span>
        <span v-if="currentArticle"> / {{ sideMenu[activeSide] }}</span>
      </span>
    </div>
    <div class="detail-layout">
      <div class="detail-sidebar">
        <div class="sidebar-title">政务资讯</div>
        <div class="side-menu">
          <div v-for="(item, index) in sideMenu" :key="index"
            class="side-item" :class="{ active: activeSide === index }"
            @click="onTabClick(index)">{{ item }}</div>
        </div>
      </div>
      <div class="detail-content">
        <template v-if="!currentArticle">
          <div class="content-header">
            <div class="content-title">{{ sideMenu[activeSide] }}</div>
          </div>
          <div class="news-list">
            <div v-for="(group, gIndex) in pagedGroups" :key="gIndex" class="list-group">
              <div v-for="(item, index) in group" :key="index" class="news-item"
                @click="openArticle(item)">
                <span class="news-dot"></span>
                <span class="news-title">{{ item.title }}</span>
                <span class="news-date">{{ formatDate(item) }}</span>
              </div>
            </div>
          </div>
          <div class="pagination">
            <span class="page-btn" @click="goFirst">首页</span>
            <span class="page-btn" @click="goPrev">上一页</span>
            <template v-for="(n, i) in pageNumbers" :key="i">
              <span v-if="n === '...'" class="page-ellipsis">...</span>
              <span v-else class="page-num" :class="{ active: currentPage === n }" @click="goPage(n)">{{ n }}</span>
            </template>
            <span class="page-btn" @click="goNext">下一页</span>
            <span class="page-btn" @click="goLast">尾页</span>
            <span class="page-info">共{{ totalPages }}页</span>
            <span class="page-jump">跳至<input type="text" v-model.number="jumpPage" class="jump-input">页<span class="jump-btn" @click="goJump">确认</span></span>
          </div>
        </template>
        <template v-else>
          <div class="detail-title">{{ currentArticle.title }}</div>
          <div class="detail-date">{{ currentArticle.date }}</div>
          <div class="detail-content">
            <div v-if="currentArticle.content" v-html="currentArticle.content"></div>
            <p v-else>{{ currentArticle.desc || currentArticle.title }}</p>
          </div>
          <div v-if="nextTitle" class="next-article" @click="goNextArticle">
            下一篇：{{ nextTitle }}
          </div>
          <div v-else class="next-article no-more">已是最后一篇</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleDetail, getArticles, getPrevNext } from '../api/index'
import pointImg from '../assets/imgs/point.png'

export default {
  name: 'GovDetail',
  props: {
    article: { type: Object, default: null },
    section: { type: String, default: '新闻资讯' },
    listA: { type: Array, default: () => [] },
    listB: { type: Array, default: () => [] },
    listC: { type: Array, default: () => [] },
    listD: { type: Array, default: () => [] },
    totalA: { type: Number, default: 0 },
    totalB: { type: Number, default: 0 },
    totalC: { type: Number, default: 0 },
    totalD: { type: Number, default: 0 },
  },
  emits: ['go-home', 'close'],
  data() {
    const sideMap = { '新闻资讯': 0, '政务信息': 1, '政务公开': 2, '政策法规': 3 }
    return {
      pointImg,
      currentArticle: null,
      nextArticle: null,
      currentIndex: -1,
      activeSide: sideMap[this.section] !== undefined ? sideMap[this.section] : 0,
      sideMenu: ['新闻资讯', '政务信息', '政务公开', '政策法规'],
      currentPage: 1,
      pageSize: 20,
      jumpPage: 1,
      listData: [],
      total: 0,
    }
  },
  computed: {
    currentData() {
      return this.listData
    },
    nextTitle() {
      return this.nextArticle ? this.nextArticle.title : ''
    },
    currentData() {
      const map = [this.listA, this.listB, this.listC, this.listD]
      return map[this.activeSide] || []
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    pagedGroups() {
      const groups = []
      for (let i = 0; i < this.listData.length; i += 5) {
        groups.push(this.listData.slice(i, i + 5))
      }
      return groups
    },
    pageNumbers() {
      const total = this.totalPages
      const cur = this.currentPage
      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1)
      }
      const pages = []
      pages.push(1, 2)
      if (cur > 3) pages.push('...')
      if (cur > 2 && cur < total - 1) pages.push(cur)
      if (cur < total - 2) pages.push('...')
      pages.push(total - 1, total)
      return [...new Set(pages)]
    },
  },
  mounted() {
    this.setArticle(this.article)
    const q = this.$route.query
    if (q.govTab) this.activeSide = parseInt(q.govTab)
    if (q.govPage) this.currentPage = parseInt(q.govPage)
    this.fetchListData()
    this._initialized = true
  },
  watch: {
    article(val) {
      this.setArticle(val)
    },
    activeSide() {
      this.currentPage = 1
      this.fetchListData()
    },
    currentPage() {
      if (this._initialized && !this._fromRoute) {
        this.$router.replace({ query: { ...this.$route.query, govPage: this.currentPage } }).catch(() => {})
      }
      this._fromRoute = false
      if (this._initialized) this.fetchListData()
    },
    '$route.query.govTab': {
      handler(val) {
        const idx = parseInt(val)
        if (!isNaN(idx) && idx !== this.activeSide) {
          this._fromRoute = true
          this.activeSide = idx
        }
      },
    },
    '$route.query.govPage': {
      handler(val) {
        const p = parseInt(val)
        if (p && p !== this.currentPage) { this._fromRoute = true; this.currentPage = p }
      },
    },
    '$route.query.govArticle': {
      handler(val) {
        if (!val) this.currentArticle = null
      },
    },
  },
  methods: {
    categoryMap() {
      return ['gov_news', 'gov_info', 'gov_public', 'policies']
    },
    async fetchListData() {
      const category = this.categoryMap()[this.activeSide]
      if (!category) return
      try {
        const res = await getArticles({ category, lang: 'zh', pageNum: this.currentPage, pageSize: this.pageSize })
        if (res.code !== 200) return
        this.total = res.total || 0
        this.listData = (res.rows || []).map(item => ({
          id: item.id,
          title: item.title,
          desc: item.summary || '',
          date: (item.publishTime || '').substring(0, 10),
        }))
      } catch (e) {
        console.error('获取列表数据失败:', e)
      }
    },
    async setArticle(item) {
      if (item) {
        this.currentArticle = { ...item }
        this.nextArticle = null
        const idx = this.currentData.findIndex(d => d.id === item.id)
        this.currentIndex = idx >= 0 ? idx : -1
        if (item.id) {
          try {
            const res = await getArticleDetail(item.id)
            if (res.code === 200 && res.data) {
              this.currentArticle = { ...item, ...res.data }
              const pn = await getPrevNext(item.id, { category: res.data.category, lang: res.data.lang || 'zh' })
              if (pn.code === 200 && pn.data) this.nextArticle = pn.data.next
            }
          } catch (e) { console.error('获取文章详情失败:', e) }
        }
      }
    },
    formatDate(item) {
      if (item.month) return item.month + '-' + item.day
      return item.date || ''
    },
    onTabClick(index) {
      this._fromRoute = true
      this.currentArticle = null
      this.activeSide = index
      const q = { ...this.$route.query, govTab: index, govPage: 1 }
      delete q.govArticle
      this.$router.replace({ query: q }).catch(() => {})
    },
    async openArticle(item) {
      this.currentArticle = { ...item }
      this.nextArticle = null
      const idx = this.currentData.findIndex(d => d.id === item.id)
      this.currentIndex = idx >= 0 ? idx : -1
      this.$router.push({ query: { ...this.$route.query, menu: 3, govArticle: item.id } }).catch(() => {})
      if (item.id) {
        try {
          const res = await getArticleDetail(item.id)
          if (res.code === 200 && res.data) {
            this.currentArticle = { ...item, ...res.data }
            const pn = await getPrevNext(item.id, { category: res.data.category, lang: res.data.lang || 'zh' })
            if (pn.code === 200 && pn.data) this.nextArticle = pn.data.next
          }
        } catch (e) {
          console.error('获取文章详情失败:', e)
        }
      }
    },
    goNextArticle() {
      if (this.nextArticle) {
        const next = this.nextArticle
        this.currentArticle = { ...next }
        this.nextArticle = null
        if (next.id) {
          this.setArticle(next)
        }
      }
    },
    goPage(n) {
      if (this.currentPage === n) return
      this.currentPage = n
    },
    goFirst() { if (this.currentPage !== 1) this.currentPage = 1 },
    goPrev() { if (this.currentPage > 1) this.currentPage-- },
    goNext() { if (this.currentPage < this.totalPages) this.currentPage++ },
    goLast() { if (this.currentPage !== this.totalPages) this.currentPage = this.totalPages },
    goJump() {
      const n = Number(this.jumpPage)
      if (n >= 1 && n <= this.totalPages && n !== this.currentPage) this.currentPage = n
    },
  },
}
</script>

<style scoped lang="less">
.gov-detail-page{
  padding-bottom: 0.4rem;
  .breadcrumb{
    padding-top: 0.2rem;
    padding-left: 0.1rem;
    padding-bottom: 0.2rem;
    font-size: 0.24rem;
    color: #666;
    display: flex;
    align-items: center;
    .breadcrumb-icon{
      width: 0.2rem;
      margin-right: 0.1rem;
    }
    .breadcrumb-link{
      cursor: pointer;
      &:hover{ color: #369BF8; }
    }
  }
  .detail-layout{
    display: flex;
    margin-top: 0.3rem;
    gap: 0.2rem;
    .detail-sidebar{
      width: 3.23rem;
      flex-shrink: 0;
      .sidebar-title{
        height: 0.7rem;
        line-height: 0.7rem;
        text-align: center;
        font-size: 0.29rem;
        color: #fff;
        background: #369BF8;
      }
      .side-menu{
        border: 1px solid #e0e0e0;
        border-top: none;
        padding: 0.2rem 0;
        .side-item{
          height: 0.7rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.24rem;
          color: #787A7B;
          cursor: pointer;
          position: relative;
          &::after{
            content: '';
            position: absolute;
            left: 0.15rem;
            right: 0.15rem;
            bottom: 0;
            height: 1px;
            background: #e0e0e0;
          }
          &:last-child::after{ display: none; }
          &.active{
            font-size: 0.27rem;
            color: #1372C9;
            gap: 0.08rem;
            &::before{
              content: '';
              width: 0;
              height: 0;
              border-top: 0.06rem solid transparent;
              border-bottom: 0.06rem solid transparent;
              border-left: 0.09rem solid #369BF8;
              flex-shrink: 0;
            }
          }
        }
      }
    }
    .detail-content{
      flex: 1;
      min-width: 0;
      min-height: 10rem;
      padding: 0 0.25rem;
      .content-header{
        border-bottom: 1px solid #e0e0e0;
        margin-bottom: 0.15rem;
        .content-title{
          display: inline-block;
          font-size: 0.27rem;
          color: #1372C9;
          border-bottom: 2px solid #1372C9;
          padding-bottom: 0.02rem;
          margin-bottom: -1px;
        }
      }
      .detail-title{
        font-size: 0.32rem;
        font-weight: bold;
        color: #000;
        text-align: center;
        margin-bottom: 0.15rem;
      }
      .detail-date{
        font-size: 0.18rem;
        color: #999;
        text-align: center;
        margin-bottom: 0.3rem;
      }
      .detail-content{
        p{
          font-size: 0.2rem;
          color: #4F4E4E;
          line-height: 2;
          text-indent: 2em;
          margin-bottom: 0.15rem;
        }
      }
      .next-article{
        margin-top: 0.4rem;
        font-size: 0.2rem;
        color: #369BF8;
        cursor: pointer;
        text-align: left;
        &:hover{ color: #1a6bb5; }
      }
      .news-list{
        .list-group{
          margin-bottom: 0.15rem;
          &:last-child{
            margin-bottom: 0;
          }
        }
        .news-item{
          display: flex;
          align-items: center;
          padding: 0.1rem 0.3rem 0.1rem 0;
          cursor: pointer;
          &:hover{
            background: rgba(0,0,0,.03);
          }
          .news-dot{
            width: 0.05rem;
            height: 0.05rem;
            border-radius: 50%;
            background: #0E8064;
            flex-shrink: 0;
            margin-right: 0.1rem;
          }
          .news-title{
            flex: 1;
            min-width: 0;
            font-size: 0.19rem;
            color: #2C2C2C;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 0.2rem;
          }
          .news-date{
            font-size: 0.19rem;
            color: #989898;
            flex-shrink: 0;
          }
        }
      }
      .pagination{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.05rem;
        margin: 0.4rem;
        flex-wrap: wrap;
        .page-btn, .page-num, .jump-btn{
          padding: 0.05rem 0.12rem;
          border: 1px solid #d9d9d9;
          font-size: 0.16rem;
          color: #333;
          cursor: pointer;
          user-select: none;
          background: #fff;
          &:hover{
            border-color: #369BF8;
            color: #369BF8;
          }
        }
        .page-num.active{
          background: #369BF8;
          color: #fff;
          border-color: #369BF8;
        }
        .page-info{
          font-size: 0.16rem;
          color: #666;
          margin-left: 0.1rem;
        }
        .page-jump{
          font-size: 0.16rem;
          color: #666;
          margin-left: 0.1rem;
          .jump-input{
            width: 0.5rem;
            height: 0.25rem;
            border: 1px solid #d9d9d9;
            text-align: center;
            font-size: 0.16rem;
            margin: 0 0.05rem;
            outline: none;
            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button{
              -webkit-appearance: none;
            }
          }
          .jump-btn{
            margin-left: 0.05rem;
          }
        }
      }
    }
  }
}
</style>
